export const DELAY_MS = 5000;
export const MIN_SLIDES_TO_DISPLAY_NAVIGATION = 2;
